import React from "react";
import { Box } from "@mui/material";
import HeroSection from "./sections/HeroSection";
import StatsSection from "./sections/StatsSection";
import TestimonialsSection from "./sections/TestimonialsSection";
import TrustedLogosSection from "./sections/TrustedLogosSection";
import RealResultsSection from "./sections/RealResultsSection";
import ComparisonSection from "./sections/ComparisonSection";
import MissionSection from "./sections/MissionSection";
import "./testimonialsPage.css";

const TestimonialsPage = () => {
  return (
    <Box
      className="testimonials-page-container"
      sx={{
        width: "100%",
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#ffffff",
      }}
    >
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
        }}
      >
        {/* Hero Section */}
        <HeroSection />

        {/* Stats Section */}
        <StatsSection />

        {/* Testimonials Section */}
        <TestimonialsSection />

        {/* Trusted Logos Section */}
        <TrustedLogosSection />

        {/* Real Results Section */}
        <RealResultsSection />

        {/* Comparison Section */}
        <ComparisonSection />

        {/* Mission Section */}
        <MissionSection />
      </Box>
    </Box>
  );
};

export default TestimonialsPage;

